/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { BidiModule } from '@angular/cdk/bidi';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzProgressModule } from 'ng-zorro-antd/progress';

import { NzStepComponent } from './step.component';
import { NzStepsComponent } from './steps.component';

@NgModule({
  imports: [BidiModule, CommonModule, NzIconModule, NzOutletModule, NzProgressModule],
  exports: [NzStepsComponent, NzStepComponent],
  declarations: [NzStepsComponent, NzStepComponent]
})
export class NzStepsModule {}
